// External deps
import { useEffect } from 'react';
import PropTypes from 'prop-types';

// Internal deps
import Message from '../../../../../components/Message/Message';
import { statusEnum } from '../../../../../utils/dataStatus';
import { MessagePermissions } from '../../../../../components/MonthlyServiceRequest/RequestDetailTypes';

const Messages = (props) => {
  const {
    idStatus,
    setUpdateNewMessage,
    isMonthly,
    messagePermissions,
    setIsPendingAuthorization
  } = props;
  const disabled =
    idStatus === statusEnum.finalizada ||
    idStatus === statusEnum.cancelada ||
    !messagePermissions.write;

  useEffect(() => {
    setIsPendingAuthorization(false);
    setUpdateNewMessage(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Message disabled={disabled} isMonthly={isMonthly} />
    </div>
  );
};

Messages.propTypes = {
  idStatus: PropTypes.number.isRequired,
  isMonthly: PropTypes.bool,
  messagePermissions: MessagePermissions,
  setUpdateNewMessage: PropTypes.func.isRequired,
  setIsPendingAuthorization: PropTypes.func
};

Messages.defaultProps = {
  isMonthly: false,
  messagePermissions: PropTypes.shape({
    visualize: false,
    write: false
  }),
  setIsPendingAuthorization: () => {}
};

export default Messages;
